import React from 'react';
import * as PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import questionModules from '../utils/Questions';
import ModuleSummaryRow from './ModuleSummaryRow';

function ModuleSummary({ moduleCompleteness }) {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          <ModuleSummaryRow
            module="A"
            percentAnswered={moduleCompleteness.A}
          />
          {Object.keys(questionModules).map((moduleKey) => {
            return (
              <ModuleSummaryRow
                key={moduleKey}
                module={moduleKey}
                percentAnswered={moduleCompleteness[moduleKey]}
              />
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

ModuleSummary.propTypes = {
  /** An object containing keys for each module and percentage or "insufficient" const as values */
  moduleCompleteness: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool])
  ).isRequired
};

export default ModuleSummary;
